import React from "react";
import styled from "styled-components";
import Select from "react-select";
import { getFontSize } from "utils/text-styles";

export const SelectStyle = styled(Select)`
  background-color: ${(props) =>
    props.theme.theme.SELECT.INPUT.BACKGROUND} !important;
  font-size: ${(props) =>
    getFontSize(props.theme.fontSize, "text")} !important; 
  #react-select-3-placeholder{
    font-size: ${(props) =>
    getFontSize(props.theme.fontSize, "text")} !important; 
  }
`;
